import MapToolMode from "lib/enums/maptoolmode";

interface MapToolModeOptionProps {
	mapToolMode:MapToolMode,
	onClickOverride?:Function,
	isSelected?:Function
}

export default class MapToolModeOption implements MapToolModeOptionProps {
	public mapToolMode:MapToolMode;
	public onClickOverride:Function;
	public isSelected:Function;
	
	constructor({mapToolMode, onClickOverride, isSelected}:MapToolModeOptionProps) {
		this.mapToolMode = mapToolMode;
		this.onClickOverride = onClickOverride;
		this.isSelected = isSelected ?? ((currentMode:MapToolMode) => currentMode == this.mapToolMode);
	}
}